"use client"

import { createContext, useContext, ReactNode } from "react"

const CopilotActiveContext = createContext(false)

export function CopilotActiveProvider({
  active,
  children,
}: {
  active: boolean
  children: ReactNode
}) {
  return (
    <CopilotActiveContext.Provider value={active}>
      {children}
    </CopilotActiveContext.Provider>
  )
}

export function useCopilotActive(): boolean {
  return useContext(CopilotActiveContext)
}
